import { useRef, useState } from 'react';

import { UnsavedChangesModal } from '@/sections/insights/queryBuilder/components/Modals';
import { useQueryBuilder } from '@/sections/insights/queryBuilder/state/useQueryBuilder';

type PendingAction = () => void;

export const useUnsavedChangesPrompt = () => {
  const { queryState } = useQueryBuilder();
  const isDirty = queryState?.isDirty ?? false;
  const [isOpen, setIsOpen] = useState(false);
  const pendingActionRef = useRef<PendingAction | null>(null);

  const confirmIfDirty = (action: PendingAction) => {
    if (!isDirty) {
      action();
      return;
    }

    pendingActionRef.current = action;
    setIsOpen(true);
  };

  const handleConfirm = () => {
    const pending = pendingActionRef.current;
    pendingActionRef.current = null;
    setIsOpen(false);
    pending?.();
  };

  const handleCancel = () => {
    pendingActionRef.current = null;
    setIsOpen(false);
  };

  const modal = (
    <UnsavedChangesModal
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );

  return { confirmIfDirty, modal, isDirty };
};
